module.exports = __webpack_public_path__ + "img/ic_flag_blue.a4ef5771.svg";